import { FC, ReactElement } from "react";
import cx from "classnames";
import { useRouter } from "next/router";
import Link from "next/link";
import { useRoutes } from "@/hooks";
import Tabs, { Tab } from "@/components/Tabs";
import styles from "./MobileSubroutesTabs.module.scss";

type Props = {
  isLoading: boolean;
};

const MobileSubroutesTabs: FC<Props> = ({ isLoading }) => {
  const { getMatchedRoute, getMatchedSubroute } = useRoutes();
  const { pathname } = useRouter();
  const { route } = getMatchedRoute();
  const subroutes = route?.children || [];
  const subroute = getMatchedSubroute();

  const tabValue = pathname.includes(subroute?.path || "");

  if (isLoading) {
    return <div />;
  }

  return (
    <Tabs
      className={cx(styles.tabs)}
      value={subroute?.path}
      variant="scrollable"
      // scrollButtons="auto"
      TabIndicatorProps={{ style: { display: "none" } }}
      id="mobile-tabs"
    >
      {subroutes.map(({ path, name, icon: Icon, disabled }) => (
        <Link
          href={path}
          passHref
          key={path}
          //@ts-ignore
          value={path}
        >
          <Tab
            aria-selected={path === pathname}
            label={name}
            icon={Icon && <Icon variant="outlined" />}
            tabIndex={0}
            iconPosition="top"
            value={path}
            className={cx(styles.tab, {
              [styles.selectedTab]: path === subroute?.path,
              [styles.largeTab]:
                name === "Flight Details" ||
                name === "Accommodation" ||
                name === "Animal Welfare",
            })}
            disabled={disabled}
          />
        </Link>
      ))}
    </Tabs>
  );
};

export default MobileSubroutesTabs;
